<template>
    <div
        class="rounded-md bg-white shadow-card w-full flex flex-col pt-8 pl-8 pb-13"
    >
        <h4 class="text-xl normal font-bold">{{ title }}</h4>
        <div class="w-9 h-1 bg-blue-900 rounded-md mt-4 mb-4" />
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<style></style>
